import * as React from 'react';
import { ReactComponent as Icon } from './baseline-add.svg';
import './add.css';

const AddIcon: React.StatelessComponent = () => <Icon className="icon-add" />;

export default AddIcon;
